import React, { useEffect, useState } from 'react';
// import banner3 from "../../assets/carrerimage.jpg";
import axios from "axios";
import "./carrer.css";
// import img from "../../assets/contact-image.png";
import { FaArrowRight } from 'react-icons/fa';

const JobAccordion = ({ job }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
    // resume: null, // file input
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [submitted, setSubmitted] = useState(false);   // ✅ FIXED


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://redite.in/php/sendemail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Server response:", result);

      if (result.success) {
        setStatus("Mail sent successfully ✔");
        setSubmitted(true);  // ✅ Show success message
        setFormData({ name: "", email: "", mobile: "", message: "" });
      } else {
        setStatus("Failed to send mail ❌");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStatus("Error sending mail ❌");
    }

    setLoading(false);
  };

  return (
    <div className="mb-4 border rounded p-3 shadow-sm">
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
      >
        <h5 className="mb-0" style={{ color:"#585887"}}>{job.title}</h5>
        <span style={{ fontSize: '1.5rem',  color:"#585887", transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.3s' }}>
          ▼
        </span>
      </div>

      {isOpen && (
        <div className="mt-3">
          <div className='career-card'>
            <h6>Role</h6>
            <p>{job.role}</p>
            <h6>Experience Required</h6>
            <p>{job.experience}</p>
            <h6>Location</h6>
            <p>{job.location}</p>
          </div>
          <div className='career-card'>
            <h6>Job Description</h6>
            <ul>
              <ul>
                {Array.isArray(job.description) ? (
                  job.description.map((item, idx) => <li key={idx}>{item}</li>)
                ) : (
                  <>
                    {job.jd1 && <li>{job.jd1}</li>}
                    {job.jd2 && <li>{job.jd2}</li>}
                    {job.jd3 && <li>{job.jd3}</li>}
                    {job.jd4 && <li>{job.jd4}</li>}
                    {job.jd5 && <li>{job.jd5}</li>}
                    {job.jd6 && <li>{job.jd6}</li>}
                    {job.jd7 && <li>{job.jd7}</li>}
                    {job.jd8 && <li>{job.jd8}</li>}
                    {job.jd9 && <li>{job.jd9}</li>}
                    {job.jd10 && <li>{job.jd10}</li>}


                  </>
                )}
              </ul>

            </ul>
          </div>
          <div className='career-card'>
            <h6>Required Key Skills</h6>
            <ul>


              <ul>
                {Array.isArray(job.skills) ? (
                  job.skills.map((skill, idx) => <li key={idx}>{skill}</li>)
                ) : (
                  <>
                    {job.skill1 && <li>{job.skill1}</li>}
                    {job.skill2 && <li>{job.skill2}</li>}
                    {job.skill3 && <li>{job.skill3}</li>}
                    {job.skill4 && <li>{job.skill4}</li>}
                    {job.skill5 && <li>{job.skill5}</li>}
                    {job.skill6 && <li>{job.skill6}</li>}
                    {job.skill7 && <li>{job.skill7}</li>}
                    {job.skill8 && <li>{job.skill8}</li>}
                  </>
                )}
              </ul>
            </ul>

          </div>
          <div>
            <button onClick={() => setShowForm(true)} style={{
              padding: "10px 18px",
              fontSize: "16px",
              backgroundColor: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer"
            }}>
              Apply Now
            </button>


            {showForm && (
              <div className="popup">
                <form className="popup-inner" onSubmit={handleSubmit}>

                  
                  <h3>Apply Now</h3>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="mobile Number"
                    required
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    name="message"
                    placeholder="message"
                    required
                    value={formData.message}
                    onChange={handleChange}
                  />
                  {/* <input
                    type="file"
                    name="resume"
                    accept=".pdf,.doc,.docx"
                    onChange={handleChange}
                  /> */}
                  <button type="submit">
                    {loading ? "Sending..." : "Submit Application"}</button>
                  <button type="button" onClick={() => setShowForm(false)}>Close</button>
                </form>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

function Carrer() {
  const [jobData, setJobData] = useState([]);

  const fetchJobs = async () => {
  try {
    const response = await axios.get(
      "https://crm.fazoacademy.in/php/career.php"
    );

    const jsonString = response.data.substring(
      response.data.indexOf("[")
    );
    const parsed = JSON.parse(jsonString);

    // ✅ ONLY REDITE JOBS
    const onlyRedite = Array.isArray(parsed)
      ? parsed.filter(
          (job) => job.types?.toLowerCase() === "redite"
        )
      : [];

    setJobData(onlyRedite);
  } catch (error) {
    console.error(error);
    setJobData([]);
  }
};

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <>
      {/* HEADER */}
      <section className='contact-uss-section'>
        <div className="about-header" data-aos="fade-down">
          <span className="about-breadcrumb">
            <a style={{ color: "#3a3a5e" }} href="/">Home</a> <FaArrowRight /> <a href="/career">Career</a>
          </span>
          <h1 className="about-heading">Career</h1>
          <p className="about-description">
Get in touch with us to explore career opportunities and support          </p>
        </div>

        <div className='container'>
          <div className='contact-us-section' data-aos="fade-right">
            {/* <h5>Current Openings</h5> */}
            <h2>Current Openings</h2>
            <p>
              Have questions about this role or ready to take the next step in your career?
              <br />
              Apply today and explore how you can grow with our team.
            </p>

          </div>

          {/* CONTACT CARDS */}

        </div>
      </section>

      <section>
        <div className='container mt-5'>
          {/* <h2 className="text-center mb-4" style={{ textTransform: "uppercase" }}>Current Openings</h2> */}
          {jobData.length > 0 ? (
            jobData.map((job, index) => (
              <JobAccordion key={index} job={job} />
            ))
          ) : (
            <p className="text-center">No openings available at the moment.</p>
          )}
        </div>
      </section>
    </>
  );
}

export default Carrer;
